module.exports = __webpack_public_path__ + "img/avad_no.30f6ac07.png";